(() => {
  let initialized = false;
  let client;
  let capturing = false;

  function syncConsent() {
    const privacy = window.Shopify?.customerPrivacy;
    const allowed = !!privacy && privacy.currentVisitorConsent().analytics !== 'no';

    if (client) {
      if (allowed && !capturing) {
        client.opt_in_capturing();
        client.capture('$pageview');
        client.startSessionRecording();
      } else if (!allowed && capturing) {
        client.stopSessionRecording();
        client.opt_out_capturing();
      }
      capturing = allowed;
      return;
    }

    // Record by default; a saved or newly collected analytics refusal stops capture.
    if (!allowed || initialized) return;
    initialized = true;

    // PostHog's installation snippet; the phc_ token is a public project token.
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}p||((p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",p.onerror=function(){p=null},(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r));var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],Object.defineProperty(u,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e}}),Object.defineProperty(u.people,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(){return u.toString(1)+".people (stub)"}}),o="vu pu gu mu init Gu Qu Hu Wu Xu il Vu Yu ju oc ac lc uc cc hc capture getExtension Zu hu gc calculateEventProperties vc register register_once register_for_session unregister unregister_for_session zu mc getFeatureFlag getFeatureFlagPayload getFeatureFlagResult getAllFeatureFlags isFeatureEnabled reloadFeatureFlags updateFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys onActiveMatchingSurveysChanged renderSurvey displaySurvey cancelPendingSurvey canRenderSurvey canRenderSurveyAsync wc identify setPersonProperties unsetPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset kc shutdown setIdentity clearIdentity get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException addExceptionStep captureLog startExceptionAutocapture stopExceptionAutocapture loadToolbar get_property getSessionProperty yc nc createPersonProfile setInternalOrTestUser bc xu ku opt_in_capturing opt_out_capturing Su has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing tc debug nl Os getPageViewId captureTraceFeedback captureTraceMetric Du".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
    window.posthog.init('phc_ros4XEURoqBuzW8qarHcr9uvZtu59iZw8ef8E2mhVJ4i', {
      api_host: 'https://eu.i.posthog.com',
      defaults: '2026-05-30',
      person_profiles: 'identified_only',
      autocapture: false,
      capture_pageview: false,
      capture_pageleave: false,
      opt_out_capturing_by_default: true,
      opt_out_persistence_by_default: true,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '[data-ph-mask], [contenteditable]',
      },
      loaded(posthog) {
        client = posthog;
        client.register({ susur_preview: window.Shopify.theme?.role !== 'main' });
        // Consent may have changed while the SDK was downloading.
        syncConsent();
      },
    });
  }

  document.addEventListener('visitorConsentCollected', syncConsent);
  if (window.Shopify?.customerPrivacy) {
    syncConsent();
  } else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
      if (!error) syncConsent();
    });
  }
})();
